import React from "react";

export function Selectform({ choices = [], question_type, placeholder, selectedvalue, ...restprops }) {
    const options = Object.entries(choices).map(([key, value]) => (
        <option class="text-dark" key={key} value={key} selected={selectedvalue===key}>{value}</option>
    ));
  return (
        <select
            class="form-select form-select-bold"
            {...restprops}
        >
            <option value="" >{placeholder}</option>
            {question_type ? options :
            choices &&
                choices.map((choice, index) => (
                    <option class="text-dark" value={choice} selected={selectedvalue===choice}>
                    {choice}
                    </option>
                ))
            };
            
        </select>
  );
}
